import {
    Button,
    Container, Grid
} from '@material-ui/core'
import { Cached } from '@material-ui/icons'
import * as React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionTitle } from '../../components/atoms/SectionTittle'
import { getStartedGame } from '../../services/game-services'
import { invoke, makeLocalUri } from '../../utils/helper'
import { StartedGameDto } from '../../utils/types'

export const GameMonitoring: React.FC = () => {
    const { state }: { state: { game: StartedGameDto }} = useLocation()
    const [game, setGame] = React.useState<StartedGameDto>(() => state?.game)

    const refresh = async () => {
        await invoke(async () => {
            setGame(
                await getStartedGame(game.gameId)
            )
        })
    }

    if (!game) {
        return <Redirect to="/" />
    }

    return (
        <PageWrapper>
            <SectionTitle text="Spilovervågning"/>
            <Container>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div>
                        <a
                            style={{ color: '#33949E', textDecoration: 'none', letterSpacing: 1 }}
                            href={makeLocalUri(`/spil/${game.gameId}`)}>
                            Overvågningslink
                        </a>
                        <div style={{
                            color: 'white', display: 'flex', alignItems: 'center', marginTop: 15
                        }}>
                            <Cached/>
                            <Button
                                style={{ color: 'white', fontSize: 14, textTransform: 'lowercase' }}
                                onClick={refresh}>
                                Opdater Svar
                            </Button>

                        </div>

                    </div>

                    <Grid
                        lg={12}
                        style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                        {game.puzzles.map((pz) => {
                            return (
                                <Grid
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    item
                                    style={{
                                        padding: 5,
                                        width: 320,
                                        height: 200,
                                        backgroundColor: 'black',
                                        margin: 15,
                                        borderRadius: 20
                                    }}>
                                    <p
                                        style={{
                                            textAlign: 'center',
                                            color: 'white',
                                        }}>
                                        Opgave {pz.puzzleId}
                                    </p>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                        {pz.startedAt
                                && (
                                    <>
                                        <p style={{ color: 'white', fontWeight: 500 }}>Svar</p>
                                        <ul style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            margin: 0,
                                            padding: 0,
                                            justifyContent: 'space-between'
                                        }}>

                                            {pz.tasks.map((t) => {
                                                return (
                                                    <li style={{
                                                        listStyle: 'none',
                                                        padding: '0px 10px',
                                                        color: t.correct ? 'green' : 'red'
                                                    }}>
                                                        {t.answer}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </>
                                )}
                                    </div>
                                </Grid>
                            )
                        })}
                    </Grid>

                </div>
            </Container>

        </PageWrapper>
    )
}
